import React, { useState } from 'react';
import { TeklifBilgisi, UrunBilgisi } from '../types';

interface TeklifFormProps {
  teklifBilgisi: TeklifBilgisi;
  onGuncelle: (yeniTeklif: TeklifBilgisi) => void;
}

const TeklifForm: React.FC<TeklifFormProps> = ({ teklifBilgisi, onGuncelle }) => {
  const handleAliciChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onGuncelle({
      ...teklifBilgisi,
      alici: e.target.value
    });
  };

  const handleTarihChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onGuncelle({
      ...teklifBilgisi,
      tarih: e.target.value
    });
  };

  const handleSaatChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onGuncelle({
      ...teklifBilgisi,
      saat: e.target.value
    });
  };

  const handleUrunChange = (index: number, field: keyof UrunBilgisi, value: any) => {
    const yeniUrunler = [...teklifBilgisi.urunler];
    yeniUrunler[index] = {
      ...yeniUrunler[index],
      [field]: value
    };

    // Satış toplamını hesapla
    if (field === 'metrekare' || field === 'birimFiyat') {
      const metrekare = field === 'metrekare' ? parseFloat(value) : parseFloat(String(yeniUrunler[index].metrekare));
      const birimFiyat = field === 'birimFiyat' ? parseFloat(value) : yeniUrunler[index].birimFiyat;
      yeniUrunler[index].satisToplam = Math.round(metrekare * birimFiyat);
    }

    onGuncelle({
      ...teklifBilgisi,
      urunler: yeniUrunler
    });
  };

  const handleKDVChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onGuncelle({
      ...teklifBilgisi,
      kdvDahil: e.target.checked
    });
  };

  const ekleYeniUrun = () => {
    const yeniUrun: UrunBilgisi = {
      id: Date.now().toString(),
      metrekare: 0,
      aciklama: '',
      birimFiyat: 0,
      satisToplam: 0
    };

    onGuncelle({
      ...teklifBilgisi,
      urunler: [...teklifBilgisi.urunler, yeniUrun]
    });
  };

  const silUrun = (index: number) => {
    const yeniUrunler = teklifBilgisi.urunler.filter((_, i) => i !== index);
    onGuncelle({
      ...teklifBilgisi,
      urunler: yeniUrunler
    });
  };

  return (
    <div className="teklif-form">
      <h2>Teklif Bilgileri</h2>
      
      <div className="form-group">
        <label htmlFor="alici">Alıcı</label>
        <input 
          type="text" 
          id="alici" 
          value={teklifBilgisi.alici} 
          onChange={handleAliciChange} 
        />
      </div>
      
      <div className="form-group">
        <label htmlFor="tarih">Tarih</label>
        <input 
          type="text" 
          id="tarih" 
          value={teklifBilgisi.tarih} 
          onChange={handleTarihChange} 
        />
      </div>
      
      <div className="form-group">
        <label htmlFor="saat">Saat</label>
        <input 
          type="text" 
          id="saat" 
          value={teklifBilgisi.saat} 
          onChange={handleSaatChange} 
        />
      </div>
      
      <h3>Ürünler</h3>
      <table style={{ width: '100%' }}>
        <thead>
          <tr>
            <th style={{ width: '40px' }}></th>
            <th>Metrekare</th>
            <th>Açıklama</th>
            <th>Birim Fiyatı</th>
            <th>Satış Toplamı</th>
          </tr>
        </thead>
        <tbody>
          {teklifBilgisi.urunler.map((urun, index) => (
            <tr key={urun.id}>
              <td style={{ textAlign: 'center' }}>
                <button 
                  onClick={() => silUrun(index)} 
                  style={{
                    backgroundColor: '#ff5252',
                    color: 'white',
                    border: 'none',
                    borderRadius: '50%',
                    width: '25px',
                    height: '25px',
                    fontSize: '14px',
                    fontWeight: 'bold',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    margin: '0 auto'
                  }}
                >
                  ✕
                </button>
              </td>
              <td>
                <input 
                  type="number" 
                  step="0.01"
                  value={urun.metrekare} 
                  onChange={(e) => handleUrunChange(index, 'metrekare', e.target.value)} 
                  style={{ width: '100%' }}
                />
              </td>
              <td>
                <input 
                  type="text" 
                  value={urun.aciklama} 
                  onChange={(e) => handleUrunChange(index, 'aciklama', e.target.value)} 
                  style={{ width: '100%' }}
                />
              </td>
              <td>
                <input 
                  type="number" 
                  value={urun.birimFiyat} 
                  onChange={(e) => handleUrunChange(index, 'birimFiyat', parseInt(e.target.value))} 
                  style={{ width: '100%' }}
                />
              </td>
              <td style={{ textAlign: 'right' }}>{urun.satisToplam.toLocaleString('tr-TR')}</td>
            </tr>
          ))}
        </tbody>
      </table>
      
      <div style={{ marginTop: '15px', marginBottom: '15px' }}>
        <button 
          className="button" 
          onClick={ekleYeniUrun}
          style={{
            backgroundColor: '#4CAF50',
            color: 'white',
            border: 'none',
            padding: '8px 15px',
            borderRadius: '4px',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: '5px'
          }}
        >
          <span style={{ fontSize: '16px', fontWeight: 'bold' }}>+</span> Yeni Ürün Ekle
        </button>
      </div>
      
      <div className="form-group" style={{ marginTop: '1rem' }}>
        <label style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <input 
            type="checkbox" 
            checked={teklifBilgisi.kdvDahil} 
            onChange={handleKDVChange} 
            style={{ width: 'auto' }}
          />
          KDV Dahildir
        </label>
      </div>
      
      <div className="total" style={{ marginTop: '20px', textAlign: 'right', fontSize: '18px' }}>
        <strong>Toplam Tutar: {teklifBilgisi.toplamTutar.toLocaleString('tr-TR')} TL</strong>
      </div>
    </div>
  );
};

export default TeklifForm; 